import { Link, useParams } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import {
  BurgerButton,
  CollapsingMenu,
  LogoutButton,
  MultiplePartnersSelector,
  RowLinks,
} from './components';
import { headerLinks } from '@shared';
import { useHeaderHook } from './Header.hook';
import { SearchBar } from '../SearchBar';

import * as S from './Header.styled';
import LOGO from './assets/header-logo.svg';
import { MyParams } from 'App';
import { ContactProctorFreeButton } from './components/ContactProctorFreeButton';

export type HeaderLinkType = typeof headerLinks[number];

export function Header() {
  const {
    isOpen,
    setIsOpen,
    filteredHeaderLinks,
    initialPage: logoLink,
    isOnline,
    isShowSearchBar,
    isMultiplePartners,
    partners,
  } = useHeaderHook();

  const { partner } = useParams<keyof MyParams>() as MyParams;
  const value = partners && partners.find((i) => i.id === partner);

  return (
    <S.AppBar isOnline={isOnline}>
      <Toolbar component='nav' sx={{ justifyContent: 'space-between' }}>
        <S.LeftSide>
          <Link style={{ lineHeight: 0 }} to={logoLink}>
            <img src={LOGO} alt='logo' width={126} height={25} />
          </Link>
          <Box display='flex' alignItems='center' gap={1}>
            {isShowSearchBar && (
              <SearchBar isMultiplePartners={isMultiplePartners} partners={partners} />
            )}
            {isMultiplePartners && value && (
              <MultiplePartnersSelector value={value} partners={partners} />
            )}
            <BurgerButton onClick={() => setIsOpen((prev) => !prev)} isActive={isOpen} />
          </Box>

          <RowLinks links={filteredHeaderLinks} />
        </S.LeftSide>
        <S.RightSide>
          <ContactProctorFreeButton />
          <LogoutButton />
        </S.RightSide>
      </Toolbar>
      <CollapsingMenu
        links={filteredHeaderLinks}
        isOpen={isOpen}
        handleClose={() => setIsOpen(false)}
      />
    </S.AppBar>
  );
}
